import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLocation } from "react-router-dom";
import { Toast, ToastContainer } from "react-bootstrap";
import { baseURL } from "../../config";

const StartofYear = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [file, setFile] = useState(null);
  const nominationid = searchParams.get("awid");
  const [showToast, setShowToast] = useState(false);
  const [currentTemplate, setCurrentTemplate] = useState(null);
  const [justifications, setJustifications] = useState({
    Creativity: [],
    Profitability: [],
    Contribution_to_OmanSATS: [],
    Last_three_years_performance_appraisal_rate: [],
    Personal_Details: [],
  });
  const [teamMembers, setTeamMembers] = useState([]);
  const [awardDatavalues, setAwardDataValues] = useState([]);

  const [title, setTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [year, setYear] = useState(null);

  let path = location.pathname;

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        let response = [];
        let template = [];
        let jsontemplate = [];
        if (nominationid != null) {
          if (path == "/startofyear") {
            setTitle("Star of the Year");
            response = await axios.get(
              `${baseURL}/getStarAwardNomination?nid=` + nominationid
            );
          } else if (path == "/employeeofdept") {
            setTitle("Employee of the Department");
            response = await axios.get(
              `${baseURL}/getEODeptAwardNomination?nid=` +
                nominationid
            );
          }
          template = response.data.template[0];
          setAwardDataValues(template);
          jsontemplate = JSON.parse(template.question_answers);
          setCurrentTemplate(jsontemplate);
        } else {
          if (path == "/startofyear") {
            setTitle("Star of the Year");
          } else {
            setTitle("Employee of the Department");
          }
          response = await axios.get(`${baseURL}/getStarTemplate`);
          template = response.data.template[0];
          jsontemplate = JSON.parse(template.questionsjson);
          setCurrentTemplate(jsontemplate);
        }
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    };

    fetchTemplate();
  }, [nominationid]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const id = localStorage.getItem("employeeid");
        const response = await axios.get(
          `${baseURL}/getteamlist?id=` + id
        );
        const data = response.data;
        let arrTeamdata = data.team;
        setTeamMembers(arrTeamdata);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchData();
  }, []);

  const handleJustificationChange = (category, index, value) => {
    const newJustifications = { ...justifications };
    newJustifications[category][index] = { answer: value };
    setJustifications(newJustifications);
  };

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmSubmit = async () => {
    try {
      let id = localStorage.getItem("employeeid");

      let json_date = {};
      if (currentTemplate) {
        for (let key in currentTemplate) {
          if (currentTemplate.hasOwnProperty(key)) {
            if (key === "templateid" || key === "author") {
              json_date[key] = currentTemplate[key];
            } else {
              json_date[key] = [
                {
                  text: currentTemplate[key][0].text,
                  justification: justifications[key] || "",
                },
              ];
            }
          }
        }
      } else {
        console.error("currentTemplate is not defined");
      }

      let jsondata = JSON.stringify(json_date);

      const formData2 = {
        employeeid: formData.assignees,
        recommended_by: id,
        question_answers: jsondata,
        role: formData.role,
        month_year: year,
      };

      let updatedFormData = { ...formData2 };
      let response;

      if (file !== null) {
        updatedFormData.certificate = file;
      }

      let formDataToSend = new FormData();

      if (file !== null) {
        for (const key in updatedFormData) {
          formDataToSend.append(key, updatedFormData[key]);
        }
        if (path == "/startofyear") {
          response = await fetch(`${baseURL}/addstarofthemonth`, {
            method: "POST",
            body: formDataToSend,
          });
        } else if (path == "/employeeofdept") {
          response = await fetch(`${baseURL}/addemployeeofdept`, {
            method: "POST",
            body: formDataToSend,
          });
        }
      } else {
        if (path == "/startofyear") {
          response = await axios.post(
            `${baseURL}/addstarofthemonthnocert`,
            formData2,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        } else if (path == "/employeeofdept") {
          response = await axios.post(
            `${baseURL}/addemployeeofdeptnocert`,
            formData2,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
        }
      }

      if (response.status >= 200) {
        setFormData(null);
        setShowModal(false);
        setShowToast(true);
        if (path == "/startofyear") {
          setTimeout(() => {
            setShowToast(false);
            window.location.href = "/startofyear";
          }, 3000);
        } else {
          setTimeout(() => {
            setShowToast(false);
            window.location.href = "/employeeofdept";
          }, 3000);
        }
      } else {
        console.error("Form submission failed");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  if (!currentTemplate) {
    return <div>Loading...</div>;
  }

  const generateYearOptions = () => {
    const options = [];
    const currentYear = new Date().getFullYear();

    for (let i = currentYear - 2; i <= currentYear; i++) {
      options.push({
        value: i.toString(),
        label: i.toString(),
      });
    }

    return options;
  };

  const handleChangeYear = (selectedOption) => {
    setYear(selectedOption.value);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      let fileval = e.target.files[0];
      setFile(fileval);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          assignees: "",
          // justificationtxt: '',
          // recommendationtxt: '',
          overallrating: "",
          month_year: "",
          certificate: "",
        }}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, setFieldValue }) => (
          <Form>
            <h4>{title} Nomination:</h4>
            <div className="d-flex">
              <div className="col-lg-5 mt-2">
                <label>
                  Assignee : {awardDatavalues.employee_firstname}{" "}
                  {awardDatavalues.employee_lastname}
                </label>
                <br />
                {awardDatavalues &&
                awardDatavalues.employee_firstname ? null : (
                  <Select
                    className=""
                    name="assignees"
                    onChange={(selectedOptions) => {
                      const selectedValues = selectedOptions.value;
                      setFieldValue("assignees", selectedValues);
                    }}
                    options={teamMembers.map((member, index) => ({
                      value: member.employeeid,
                      label: member.FirstName,
                    }))}
                    getOptionLabel={(option) =>
                      `${option.label} - ${option.value}`
                    }
                    isMulti={false}
                  />
                )}
              </div>
              <div className="col-lg-5 mt-2 ml-5">
                <label>Year : {awardDatavalues.month_year}</label>
                <br />
                {awardDatavalues && awardDatavalues.month_year ? null : (
                  <Select
                    name="month_year"
                    options={generateYearOptions()}
                    value={{
                      value: values.month_year || year,
                      label: values.month_year || year,
                    }}
                    isMulti={false}
                    onChange={(selectedOption) => {
                      const selectedValue = selectedOption.value;
                      setFieldValue("month_year", selectedValue);
                      setYear(selectedValue);
                    }}
                  />
                )}
              </div>
            </div>
            <h4 className="mt-3 pt-3 pb-3 fs-3">Business Case</h4>

            <table className="w-100 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Creativity &&
                  currentTemplate.Creativity.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Creativity</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1  float-end"
                          value={
                            justifications.Creativity[index]?.answer ||
                            question.justification[index]?.answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Creativity",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <table className="w-100 mt-2 pt-3">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Profitability &&
                  currentTemplate.Profitability.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Profitability</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1 float-end"
                          value={
                            justifications.Profitability[index]?.answer ||
                            question.justification[index]?.answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Profitability",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Contribution_to_OmanSATS &&
                  currentTemplate.Contribution_to_OmanSATS.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <h3 className="pt-3 mt-2">
                            Contribution to Oman SATS
                          </h3>
                          <label className="mt-2">{question.text}</label>
                        </td>
                        <td className="p-2">
                          <textarea
                            className="w-75 m-1 p-1 float-end"
                            value={
                              justifications.Contribution_to_OmanSATS[index]
                                ?.answer ||
                              question.justification[index]?.answer ||
                              ""
                            }
                            onChange={(e) =>
                              handleJustificationChange(
                                "Contribution_to_OmanSATS",
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                            rows="6"
                            placeholder="Justification"
                          />
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Last_three_years_performance_appraisal_rate &&
                  currentTemplate.Last_three_years_performance_appraisal_rate.map(
                    (question, index) => (
                      <tr key={index}>
                        <td className="w-50">
                          <h3 className="pt-3 mt-2">
                            Last Three Years Performance Appraisal Rate
                          </h3>
                          <label className="mt-2">{question.text}</label>
                          <label className="mt-2">
                            {question.justification[index]?.answer}
                          </label>
                        </td>
                        <td className="p-2">
                          <textarea
                            className="w-75 m-1 p-1 float-end"
                            value={
                              justifications
                                .Last_three_years_performance_appraisal_rate[
                                index
                              ]?.answer ||
                              question.justification[index]?.answer ||
                              ""
                            }
                            onChange={(e) =>
                              handleJustificationChange(
                                "Last_three_years_performance_appraisal_rate",
                                index,
                                e.target.value
                              )
                            }
                            disabled={
                              awardDatavalues && awardDatavalues.month_year
                                ? true
                                : false
                            }
                            rows="6"
                            placeholder="Justification"
                          />
                        </td>
                      </tr>
                    )
                  )}
              </tbody>
            </table>

            <table className="w-100 pt-3 mt-2">
              <tbody>
                {currentTemplate != null &&
                  currentTemplate.Personal_Details &&
                  currentTemplate.Personal_Details.map((question, index) => (
                    <tr key={index}>
                      <td className="w-50">
                        <h3 className="pt-3 mt-2">Personal Details</h3>
                        <label className="mt-2">{question.text}</label>
                      </td>
                      <td className="p-2">
                        <textarea
                          className="w-75 m-1 p-1 float-end"
                          value={
                            justifications.Personal_Details[index]?.answer ||
                            question.justification[index]?.answer ||
                            ""
                          }
                          onChange={(e) =>
                            handleJustificationChange(
                              "Personal_Details",
                              index,
                              e.target.value
                            )
                          }
                          disabled={
                            awardDatavalues && awardDatavalues.month_year
                              ? true
                              : false
                          }
                          rows="6"
                          placeholder="Justification"
                        />
                      </td>
                    </tr>
                  ))}
                <tr>
                  {awardDatavalues && awardDatavalues.certifilename ? (
                    <td colSpan="2">
                      <a
                        href={`${baseURL}/getcertifcate?filename=${awardDatavalues.certifilename}`}
                        download // Add the download attribute
                      >
                        <h6> View Certificate</h6>
                      </a>
                    </td>
                  ) : (
                    <>
                      <td>
                        {!nominationid ? (
                          <>
                            <td>Upload Certificate</td>
                            <input
                              value={values.certificate}
                              id="file"
                              type="file"
                              onChange={handleFileChange}
                            />
                            {file && <p>{file.name}</p>}
                          </>
                        ) : null}
                      </td>
                    </>
                  )}
                </tr>
              </tbody>
            </table>

            <div className="col-lg-11 text-end mt-4 pb-3">
              {awardDatavalues && awardDatavalues.month_year ? (
                <Button
                  className="border-0 mt-2 p-1 btn-#8d3523 savebtn w-25"
                  type="button"
                  onClick={() => (window.location.href = "/startofyearlist")}
                >
                  Go Back to List
                </Button>
              ) : (
                <>
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    type="button"
                    className="btn cancelbtn ml-2"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </Button>
                </>
              )}
            </div>
          </Form>
        )}
      </Formik>
      <ToastContainer position="bottom-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
          className="bg-success text-white"
        >
          <Toast.Header>
            <span className="me-2">✔️</span> {/* Unicode tick mark */}
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>Success!, data updated successfully!</Toast.Body>
        </Toast>
      </ToastContainer>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Submission</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to submit the form?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleConfirmSubmit}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default StartofYear;
